import React from 'react';

function tab1(){
    return(
        <div className="row">
            <a  href="http://uigrad.netlify.app" rel="noopener noreferrer" target="_blank"><img src="./img/uigrad.jpg" alt="uiGrad" style={{width:"90%"}} /></a>
            <a  href="https://play.google.com/store/apps/details?id=com.yawlit" rel="noopener noreferrer" target="_blank"><img src="./img/yawlit.png" alt="yawlit" style={{width:"90%",}} /></a>
        </div>
    );
}
export default tab1;